import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useMangoApi } from '~/atoms/MangoApi'

import { ApiError, SipConnectionInfo } from '@mangovoice/types'

interface GetSipConnectionInfoParams {
  extensionId: number
  options?: UseQueryOptions<SipConnectionInfo, ApiError>
}
export const useGetSipConnectionInfo = ({
  extensionId,
  options,
}: GetSipConnectionInfoParams) => {
  const mangoApi = useMangoApi()

  const query = useQuery<SipConnectionInfo, ApiError>({
    queryKey: ['sip', extensionId],
    queryFn: async () => {
      if (extensionId === 0) return Promise.reject(undefined)

      const { ok, data } = await mangoApi.getSipConnectionInfo(extensionId)

      if (!ok) {
        return Promise.reject(data as ApiError)
      }
      const sipConnectionInfo = data as SipConnectionInfo
      return sipConnectionInfo
    },
    ...options,
    gcTime: options?.gcTime ?? 15 * 60 * 1000,
    retry: (options?.retry as number | boolean | undefined) ?? false,
  })

  return {
    ...query,
  }
}
